import { combineReducers } from "redux";
import userSession from "./userSession";

export default combineReducers({
  userSession: userSession,
});
